import { render } from "./AppInput.vue?vue&type=template&id=096871e1&scoped=true"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"

import "./AppInput.vue?vue&type=style&index=0&id=096871e1&scoped=true&lang=css"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096871e1"]])

export default __exports__